import { createContext, useContext } from 'react';

export const PortalDocumentContext = createContext<Document | null>(null);

export function usePortalDocument(): Document | null {
	return useContext(PortalDocumentContext);
}
